module.exports = __webpack_public_path__ + "img/schemeList05Display05.c8a2501c.jpg";